$ = require('jquery');
// var scrollmagic	= require('scrollmagic');

var isMobile, isPhablet, isTablet, isDesktop;

function updateResolution(){
    isMobile = window.innerWidth < 600;
    isPhablet = window.innerWidth < 1024 && !isMobile;
    isTablet = window.innerWidth < 1259 && !isMobile;
    isDesktop = window.innerWidth >= 1259;
}


$(function(){
    $(window).on('resize', function(){
        updateResolution();
    });
});


module.exports = {

    isMobile: function () {
        return isMobile;
    },
    isPhablet: function () {
        return isPhablet;
    },
    isTablet: function () {
        return isTablet;
    },
    isDesktop: function () {
        return isDesktop;
    },
    // scrollController: new scrollmagic.Controller()


};
